<template>
  <div class="home">
    <div class="header">
      <div class="con">
        <div class="classify" @click="clickClass">
          <div class="line" :class="{ topline : isScrollActive}"></div>
          <div class="line" :class="{ middleline : isScrollActive}"></div>
          <div class="line" :class="{ bottomline : isScrollActive}"></div>
          <!--<img src="./classify.png" alt="">-->
        </div>
        <div class="logo"><img src="../../static/logo.png" alt=""></div>
        <div class="zhixiao"><img src="../../static/zhixiao.png" alt=""></div>
      </div>
    </div>
    <div class="main">
      <div class="carousel">
        <el-carousel height="300px">
          <el-carousel-item v-for="(item,index) in carouselImg" :key="index">
            <img :src="item.imgPath" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="min_carousel">
        <el-carousel height="120px">
          <el-carousel-item v-for="(item,index) in carouselImg" :key="index">
            <img :src="item.imgPath" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="left" :class="{ scrollActive : isScrollActive}">
        <div class="scroll">
          <div class="item" v-for="(item,index) in listdata" @click="torouter(item,index)"
               :class="{active:(index === indexs)}">{{item.name}}
          </div>
        </div>
      </div>

      <div class="right">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'HelloWorld',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        carouselImg: '',
        radio: '1',
        indexs: 2,
        listdata: '',
        isScrollActive: false
      }
    },
    created() {
      axios.get('/api/getCatalog').then(response => {
        this.listdata = response.data
        console.log(response)
      })
      axios.get('/api/positions?type=10002-80').then(response => {
        this.carouselImg = response.data
        console.log(this.carouselImg, 'sssss')
      })

    },
    mounted() {

    },
    methods: {
      clickClass() {
        this.isScrollActive = !this.isScrollActive
      },
      torouter(item, index) {
        this.indexs = index
        this.$router.push({name: item.path, params: {id: item.id, name: item.name}})
        this.isScrollActive = false
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .middleline {
    transform: translateX(-50px);
    opacity: 0;
  }
  .topline {
    transform: rotate(45deg);
    transform-origin:0% 0%;
    width: 29px !important;
  }
  .bottomline {
    transform: rotate(-45deg);
    transform-origin:0% 100%;
    width: 29px !important;
  }
  .line{
    background: #000000;
    width: 28px;
    height: 2px;
    margin-bottom: 8px;
    transition: all 0.4s;
  }
  .classify {
    margin-left: 16px;
    display: none;
  }

  .carousel {
    margin-bottom: 60px;
  }

  .el-carousel__item img {
    width: 100%;
    height: 100%;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .grid-content {
    height: 230px;
    cursor: pointer;
  }

  .grid-content:hover {
    background: #dcdcdc;
  }

  .grid-content i {
    font-size: 36px;
    line-height: 230px;
  }

  .display {
    margin: 60px 0;
    height: 230px;
    width: 1200px;
    overflow: hidden;
    text-align: left;
  }

  .display .list {
    height: 100%;
    width: 2400px;
  }

  .display .list .item {
    display: inline-block;
    vertical-align: top;
    width: 230px;
    padding: 0 10px;

  }

  .animation {
    animation: mymove 10s infinite;
  }

  .display .list .item img {
    width: 100%;
  }

  .displayImg {
    width: 100%;
  }

  @keyframes mymove {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-2400px);
    }
  }

  .active {
    background-color: #fef2e3 !important;
  }

  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .header {
    background-image: url("../../static/bg.jpg");
    width: 100%;
    height: 80px;
    background-size: cover;
  }

  .header .con {
    width: 1200px;
    height: 80px;
    margin: 0 auto;
    position: relative;
  }

  .header .con .logo {
    position: absolute;
    left: 0;
    bottom: 18px;
  }

  .header .con .logo img {
    width: 360px;
  }

  .header .con .zhixiao {
    position: absolute;
    right: 0;
    bottom: 20px;
  }

  .header .con .zhixiao img {
    width: 140px;
  }

  .main {
    width: 1200px;
    margin: 0 auto;
    background: #FFFFFF;
  }

  .main .left {
    width: 260px;
    display: inline-block;
    vertical-align: top;
  }

  .main .left .item {
    width: 170px;
    padding: 0 40px;
    background-color: #fbe9d1;
    height: 50px;
    text-align: left;
    line-height: 50px;
    font-size: 14px;
    cursor: pointer;
    font-weight: 700;
  }
  .min_carousel {
    display: none;
  }
  .main .left .item:hover {
    background-color: #fef2e3;
  }

  .main .right {
    width: 920px;
    display: inline-block;
    vertical-align: top;
  }

  @media (max-width: 768px) {
    .min_carousel {
      display: block;
    }
    .header {
      height: 50px;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 9999999;
    }

    .con {
      width: 100% !important;
      height: 60px !important;
    }

    .main {
      width: 100%;
      margin: 0 auto;
      padding-top: 50px;
    }

    .header .con .logo {
      position: absolute;
      top: 0px;
      right: 0;
      left: initial;
      padding: 5px 5px 0 0;
    }

    .header .con .logo img {
      width: 110px;
    }

    .header .con .classify {
      display: block;
      position: absolute;
      top: 14px;
      left: 0px;
    }

    .header .con .classify img {
      width: 50%;
      opacity: 0.6;
    }

    .header .con .zhixiao {
      position: static;
      padding: 18px 0;
    }

    .header .con .zhixiao img {
      width: 26%;
    }

    .main .left {
      width: 220px;
      position: fixed;
      top: 50px;
      right: 0;
      left: -220px;
      bottom: 0;
      z-index: 100;
      background: #fbe9d1;
      transition: all 0.3s;
    }

    .scrollActive {
      left: 0 !important;
    }

    .main .left .scroll {
      height: auto;
    }

    .main .left .item {
      width: 160px;
      padding: 0 30px;
      background-color: #fbe9d1;
      height: 30px;
      text-align: left;
      line-height: 30px;
      font-size: 14px;
      cursor: pointer;
      font-weight: 500;
    }

    .main .right {
      width: 100%;
      display: inline-block;
      vertical-align: top;
    }

    .carousel {
      margin-bottom: 10px;
      display: none;
    }

    .el-carousel__container {
      height: 200px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue